module.exports = __webpack_public_path__ + "a7cd382726c3b27b4222267151efa346.pdf";